import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { ConfirmationNumber } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const TicketNode = memo(({ id, data, isConnectable, selected }) => {
  const queueName = data?.queueName || data?.queue?.name;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<ConfirmationNumber />}
      title="Fila"
      color="#215e97"
      bgColor="#ffffff"
      isConnectable={isConnectable}
      selected={selected}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 10px",
          borderRadius: 20,
          fontSize: 11,
          fontWeight: 600,
          backgroundColor: queueName ? "#E8F0FE" : "#f5f5f5",
          color: queueName ? "#215e97" : "#999",
          border: `1px solid ${queueName ? "#215e9730" : "#e0e0e0"}`,
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <ConfirmationNumber style={{ fontSize: 13, color: queueName ? "#215e97" : "#bbb" }} />
        {queueName || "Nenhuma fila selecionada"}
      </div>
    </NodeWrapper>
  );
});

TicketNode.displayName = "TicketNode";
export default TicketNode;
